/**
 *
 * @param key { string }
 * @param storageType { 'session' | 'local' }
 * @returns { string | null }
 */
export const getFromStorage = (key, storageType = "session") => {
  if (!key) {
    console.warn(
      "Must specify a key when attempting to get from storage",
      key,
      storageType
    );
    return null;
  }
  try {
    return storageType === "session"
      ? sessionStorage.getItem(key)
      : localStorage.getItem(key);
  } catch (err) {
    console.warn("Could not access storage", storageType, key, err);
    return null;
  }
};

/**
 * 
 * @param { string } key 
 * @param { boolean } value
 * @param { string } storageType { 'session' | 'local' }
 * @returns { string | null }
 */
export const setInStorage = (key, value, storageType = "session") => {
  if (!key) {
    console.warn(
      "Must specify a key when attempting to set from storage",
      key,
      storageType
    );
    return null;
  }
  if (!value) {
    console.warn(
      "Must specify a value when attempting to set from storage",
      key,
      storageType,
      value
    );
    return null;
  }
  try {
    const storage = storageType === "session" ? sessionStorage : localStorage;
    storage.setItem(key, value);
    return storage.getItem(key);
  } catch (err) {
    console.warn("Could not access storage", storageType, key, value, err);
    return null;
  }
};

/**
 * 
 * @param { string } key 
 * @param { string } storageType { 'session' | 'local' }
 * @returns { boolean } the item was successfully deleted from storage
 */
export const removeFromStorage = (key, storageType = "session") => {
  if (!key) {
    console.warn(
      "Must specify a key when attempting to remove from storage",
      key,
      storageType
    );
    return false;
  }
  try {
    const storage = storageType === "session" ? sessionStorage : localStorage;
    storage.removeItem(key);
    return true;
  } catch (err) {
    console.warn("Could not access storage", storageType, key, err);
    return false;
  }
};
